export default __webpack_public_path__ + "static/starcoin-illustration-dark-41156d2eb75d9e42dab9b0adad584846.svg";